import React from 'react';
import { Icon } from '../icons';

const variants = {
  info: {
    container: 'bg-primary-50 border-primary-200 text-primary-800',
    icon: 'info',
  },
  success: {
    container: 'bg-emerald-50 border-emerald-200 text-emerald-800',
    icon: 'checkCircle',
  },
  warning: {
    container: 'bg-amber-50 border-amber-200 text-amber-800',
    icon: 'alertTriangle',
  },
  error: {
    container: 'bg-red-50 border-red-200 text-red-800',
    icon: 'xCircle',
  },
};

export default function Alert({
  children,
  variant = 'info',
  title,
  icon,
  onClose,
  className = '',
}) {
  const config = variants[variant] || variants.info;

  return (
    <div
      className={`flex items-start gap-3 p-4 border rounded-lg ${config.container} ${className}`}
      role="alert"
    >
      <div className="flex-shrink-0 mt-0.5">
        {icon || <Icon name={config.icon} className="w-5 h-5" />}
      </div>
      <div className="flex-1 min-w-0">
        {title && (
          <h4 className="font-medium mb-1">{title}</h4>
        )}
        <div className="text-sm">{children}</div>
      </div>
      {onClose && (
        <button
          onClick={onClose}
          className="flex-shrink-0 p-1 rounded hover:bg-black/5 transition-colors"
          aria-label="閉じる"
        >
          <Icon name="x" className="w-4 h-4" />
        </button>
      )}
    </div>
  );
}
